export const mediaContext = {
  images: '/media-service/api/external/userImages',
  imageById: '/media-service/api/external/userImages/{id}',
  externalImages: '/media-service/api/internal/httpImages',
  multipartImages: '/media-service/api/internal/multipartImage',
};
